/*
  hidden-variant-filter.js — v2, Aug 10 2026.

  Hides individual variant COMBINATIONS from the product page picker.

  WHY JS AND NOT LIQUID: the picker renders option VALUES (Color, Size), not
  variants. The hide target is a combination — "Gravel" + 1/4" on Recreational
  Flakes. Dropping the value 1/4" would remove it for all 13 colours; dropping
  Gravel would remove its 1/8" and 1/16" too. So it has to be decided per
  selection, at runtime.

  DATA: snippets/variant-picker.liquid emits a JSON array of the option tuples
  of every variant whose custom.hidden metafield is true. That metafield MUST
  have storefront access PUBLIC_READ or the array comes back empty, silently.

  ---------------------------------------------------------------------------
  v1 BUG THIS FIXES — READ BEFORE CHANGING ANY OF THIS.

  v1 applied the rule SYMMETRICALLY: it hid any value that would produce a
  hidden combination, in every option. With Size = 1/4" selected on page load
  it asked "would Gravel + 1/4\" be hidden?", got yes, and hid the COLOUR
  Gravel. Repeated across the 8 duplicates, Recreational rendered only its 5
  non-duplicate colours. Clicking a size then changed the selection, the
  colour test stopped matching, and all 13 reappeared.

  THE RULE IS DIRECTIONAL. The FIRST option (Colour) is the one the customer
  chooses first and must always show every value. Only later options — Size —
  ever hide. Never hide in option index 0.
  ---------------------------------------------------------------------------
*/
(function () {
  "use strict";

  if (window.__sfcHiddenVariants) return;
  window.__sfcHiddenVariants = true;

  var STYLE_ID = "sfc-hidden-variant-style";
  var HIDE_CLASS = "sfc-variant-hidden";

  /*
    v1 also ran the auto-move INSIDE the repaint, so it fired synthetic change
    events while variant-picker.js was mid-update. The two raced, the variant
    failed to resolve, the URL became ?variant=undefined and the buy button
    fell back to "Sold out". Moves now happen only on load and on real user
    input, and this window suppresses the observer while one is in flight.
  */
  var suppressUntil = 0;

  function suppress(ms) {
    suppressUntil = Date.now() + (ms || 800);
  }

  function suppressed() {
    return Date.now() < suppressUntil;
  }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var el = document.createElement("style");
    el.id = STYLE_ID;
    el.textContent = "." + HIDE_CLASS + "{display:none !important;}";
    (document.head || document.documentElement).appendChild(el);
  }

  function readHidden(picker) {
    var el = picker.querySelector("[data-sfc-hidden-variants]");
    if (!el) return [];
    try {
      var parsed = JSON.parse(el.textContent || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      return [];
    }
  }

  /* Ordered by data-index so positions line up with variant.options order. */
  function orderedSelectors(picker) {
    return Array.prototype.slice
      .call(picker.querySelectorAll(".option-selector"))
      .sort(function (a, b) {
        return (
          Number(a.getAttribute("data-index") || 0) -
          Number(b.getAttribute("data-index") || 0)
        );
      });
  }

  function checkedValue(selector) {
    var input = selector.querySelector("input.js-option:checked");
    return input ? input.value : null;
  }

  function sameTuple(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      if (String(a[i]) !== String(b[i])) return false;
    }
    return true;
  }

  function tupleIsHidden(hidden, tuple) {
    for (var i = 0; i < hidden.length; i++) {
      if (sameTuple(hidden[i], tuple)) return true;
    }
    return false;
  }

  function setHidden(input, hide) {
    input.classList.toggle(HIDE_CLASS, hide);
    if (input.id) {
      var label = document.querySelector('label[for="' + input.id + '"]');
      if (label) label.classList.toggle(HIDE_CLASS, hide);
    }
  }

  function paint(picker) {
    var hidden = readHidden(picker);
    if (!hidden.length) return;

    var selectors = orderedSelectors(picker);
    if (selectors.length < 2) return;

    var current = selectors.map(checkedValue);

    /*
      Start at 1: option 0 (Colour) always shows every value. See the v1 bug
      note at the top — this single boundary is the whole fix.
    */
    for (var index = 1; index < selectors.length; index++) {
      var inputs = selectors[index].querySelectorAll("input.js-option");

      /* eslint-disable no-loop-func */
      (function (idx) {
        Array.prototype.forEach.call(inputs, function (input) {
          var tuple = current.slice();
          tuple[idx] = input.value;

          var complete = tuple.every(function (value) {
            return value !== null && value !== undefined;
          });

          setHidden(input, complete && tupleIsHidden(hidden, tuple));
        });
      })(index);
      /* eslint-enable no-loop-func */
    }
  }

  /*
    If the current selection sits on a hidden combination — the theme's
    select_first_variant landing on Gravel + 1/4", or a direct ?variant= link —
    move to the first still-visible value in that option.

    Clicks the LABEL rather than setting .checked and dispatching change: a
    label click is what a customer does, so variant-picker.js runs its normal
    path instead of being handed a synthetic event mid-render.
  */
  function moveOffHidden(picker) {
    var selectors = orderedSelectors(picker);

    for (var i = 1; i < selectors.length; i++) {
      var checked = selectors[i].querySelector("input.js-option:checked");
      if (!checked || !checked.classList.contains(HIDE_CLASS)) continue;

      var replacement = selectors[i].querySelector(
        "input.js-option:not(." + HIDE_CLASS + ")"
      );
      if (!replacement || !replacement.id) continue;

      var label = document.querySelector('label[for="' + replacement.id + '"]');
      if (!label) continue;

      suppress(800);
      label.click();
      return true;
    }

    return false;
  }

  function pickers() {
    return Array.prototype.slice.call(
      document.querySelectorAll("variant-picker")
    );
  }

  function paintAll() {
    injectStyle();
    pickers().forEach(paint);
  }

  function paintAndSettle() {
    paintAll();
    pickers().forEach(moveOffHidden);
  }

  function start() {
    paintAll();

    /* Let the theme finish its own first-variant selection, then correct it. */
    setTimeout(paintAndSettle, 400);

    if (window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        if (suppressed() || pending) return;
        pending = setTimeout(function () {
          pending = null;
          if (!suppressed()) paintAll();
        }, 60);
      }).observe(document.body, { childList: true, subtree: true });
    }

    /* A real user change is the safe moment to re-evaluate and move. */
    document.addEventListener("change", function (e) {
      if (!e.target || !e.target.classList) return;
      if (!e.target.classList.contains("js-option")) return;
      setTimeout(paintAndSettle, 0);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
